import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/temp_home_page.jpg';
import _imports_1 from '../assets/images/shui_mu_ai.png';
import _imports_2 from '../assets/images/police-regis.png';
import _imports_3 from '../assets/images/qr_image_1.png';
import _imports_4 from '../assets/images/qr_image_2.png';
const _withScopeId = n => (_pushScopeId("data-v-186c3c58"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "home_contact"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "temp_img",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "content_info"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "top_info"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "shui_mu_ai",
  src: _imports_1,
  alt: ""
}), /*#__PURE__*/_createElementVNode("span", {
  class: "title_name"
}, "全球混合模型技术引领者"), /*#__PURE__*/_createElementVNode("a", {
  class: "product_link",
  href: "https://baiwen.shuimu-ai.com/"
}, "旗下产品")]), /*#__PURE__*/_createElementVNode("div", {
  class: "text_info"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left_info"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "english"
}, "#"), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("你好，世界"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("用")]), /*#__PURE__*/_createElementVNode("span", {
  class: "english"
}, "AI"), /*#__PURE__*/_createElementVNode("span", null, "重构交互")]), /*#__PURE__*/_createElementVNode("div", {
  class: "right_info"
}, [/*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("水木智远创立于2022年。脱胎于清华大学人工智能所，是一家专注于底层混合模型技术研究以及相关服务应用的公司。水木智远在2023年于全球首个提出混合模型思路并实现了应用落地。其推出的水木大小模型协同技术，较之传统的LLM技术，不仅成本低，效果好，且较之传统的RAG方式，降低了私有数据的加载难度，提升了推理效率，从而显著降低用户侧的垂类模型训练和使用门槛，真正实现了AI能力在商业场景的部署。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 水木智远独家开发的水木AI，通过SDK方式和私有化部署方式为国内客户提供服务。水木AI现已应用于教育、直播、电商、零售等领域的头部客户。")])])])]), /*#__PURE__*/_createElementVNode("div", {
  class: "fotter_view"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "filing_information"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "icp"
}, [/*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.cac.gov.cn/",
  target: "_blank"
}, "网信算备110105218498801240011号")]), /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, "|"), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "京ICP备2022000649号-5")]), /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, "|"), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "京B2-20221396")]), /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, "|")]), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("a", {
  class: "police-regis-link",
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802040305",
  target: "_blank"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "police-regis",
  src: _imports_2,
  alt: "police-regis"
}), /*#__PURE__*/_createElementVNode("span", null, "京公网安备11010802040305号")])])]), /*#__PURE__*/_createElementVNode("div", {
  class: "company_information"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "company-icp"
}, [/*#__PURE__*/_createElementVNode("span", null, "北京水木智远科技有限公司2024版权所有©"), /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, "|"), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("span", null, "北京市朝阳区星地中心B座12层")]), /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, "|"), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("span", null, "info@shuimu-ai.com")])])])]), /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "image1",
  src: _imports_3,
  alt: ""
}), /*#__PURE__*/_createElementVNode("img", {
  class: "image2",
  src: _imports_4,
  alt: ""
})])])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({
      Component
    }) => [_hoisted_1]),
    _: 1
  });
}